import Emitter from "es6-event-emitter";

import { generateCoverURL } from "./../utilities/utils";

export default class CpStore extends Emitter {
  _apiManager = null;
  contentManager = null;

  additionalDownloadTokens = null;

  //contentPackageId
  cpID = null;
  CPackageInfo = null;
  CPackage = null;
  options = null;
  supplements = [];
  sharingUrl = null;
  nextgenSharingUrl = null;

  constructor(
    APIManager,
    ContentManager,
    contentPackageId,
    additionalDownloadTokens,
    options
  ) {
    super();
    this._apiManager = APIManager;
    this.contentManager = ContentManager;
    this.cpID = contentPackageId;
    this.additionalDownloadTokens = additionalDownloadTokens;
    this.options = options;
  }

  load() {
    this.loadInfo().then(() => {
      Promise.all([
        this.loadCp(),
        this.loadSharingUrl(),
        this.loadNextSharingUrl(),
      ]).then(() => {
        this.CPackageInfo.ProductName =
          this.options.product_name_for_engage_readers;
        for (let i = 0; i < this.additionalDownloadTokens.length; i++) {
          if (
            this.additionalDownloadTokens[i].Value ===
            this.CPackage.DownloadToken
          ) {
            this.CPackageInfo.ProductName =
              this.additionalDownloadTokens[i].Description;
          }
        }
        this.trigger("cpStore:loaded");
      });
    });
  }

  async loadSharingUrl() {
    if (this.options.shareFromReader) {
      try {
        let result = await this._apiManager.getProfileValues(
          "WebappReplicaShareUrl"
        );
        if (result && result[0] && result[0].Description) {
          this.sharingUrl = result[0].Description;
        }
      } catch (error) {
        //TODO error handling here?
      }
    }
  }

  async loadNextSharingUrl() {
    if (this.options.shareFromNextgen) {
      try {
        let result = await this._apiManager.getProfileValues(
          "WebappNextgenShareUrl"
        );
        if (result && result[0] && result[0].Description) {
          this.nextgenSharingUrl = result[0].Description;
        }
      } catch (error) {
        //TODO error handling here?
      }
    }
  }

  /**
   * makes getContentPackageInfo API call and saves response in cpStore object
   * @param {number} contentPackageId
   * @returns {void} void promise
   */
  loadInfo(contentPackageId) {
    if (contentPackageId) {
      this.cpID = contentPackageId;
    }
    return this._apiManager.getContentPackageInfo(this.cpID).then((info) => {
      this.CPackageInfo = info;
      let price = Number.MAX_SAFE_INTEGER;
      let channelPrice;
      this.CPackageInfo.StoreProducts.forEach((product) => {
        if (product.Channel == this.options.channel) {
          channelPrice = product;
        }
      });
      // const channelPrice = this.CPackageInfo.StoreProducts.find(product => (product.Channel == this.options.channel));  // bug on old browsers, don't support find
      if (channelPrice) {
        price = channelPrice.Price;
      }
      this.CPackageInfo.price = price;
    });
  }

  getVersion() {
    return this.CPackageInfo ? this.CPackageInfo.Version : undefined;
  }

  /**
   * makes getContentPackagePublications call for CP info & makes getNonExpiredShelfPublications call for all valid pubs within the CP. Pub info is normalised and added to CP info object
   * cpstore:cpLoaded is triggered
   * @returns {void} void
   */
  async loadCp() {
    this.CPackage = await this.contentManager.getContentPackagePublications(
      this.cpID
    );
    try {
      let shelf = await this.contentManager.getNonExpiredShelfPublications(
        this.cpID
      );
      this.CPackage.ContentPackagePublication =
        this.CPackage.ContentPackagePublication.concat(sort(shelf));
    } catch (error) {
      // no non-expired shelf publications for this cpid
    }
    this.normalizeContentPackagePublications();
    this.setSupplements();
    this.trigger("cpStore:cpLoaded");
    return true;
  }

  setSupplements() {
    this.CPackage.ContentPackagePublication.forEach((cpp) => {
      if (cpp.PublicationType === "Supplement") {
        this.supplements.push(cpp);
      }
    });
  }

  normalizeContentPackagePublications() {
    this.CPackage.ContentPackagePublication.forEach((cpp) => {
      cpp.label = cpp.PublicationName;
      if (cpp.ThumbnailPublicationPageId) {
        cpp.ThumbnailId = cpp.ThumbnailPublicationPageId;
      } else {
        cpp.ThumbnailId = cpp.ThumbnailPublicationPageID;
      }
      if (cpp.ContentPackageID) {
        cpp.ContentPackageId = cpp.ContentPackageID;
      }
      if (cpp.PublicationID) {
        cpp.PublicationId = cpp.PublicationID;
      }
      if (!cpp.ContentPackageId) {
        cpp.ContentPackageId = this.cpID;
      }
      if (!cpp.PublicationDate) {
        cpp.PublicationDate = this.CPackage.PublicationDate;
      }
      if (!cpp.PublicationTitleFormat) {
        cpp.PublicationTitleFormat = "Newspaper";
      }
      cpp.imageUrl = generateCoverURL(
        cpp.ContentPackageId,
        this.options.sizes.S,
        cpp.ThumbnailId,
        cpp.ContentPackageVersion || this.CPackageInfo.Version
      );
      cpp.imageLargeUrl = generateCoverURL(
        cpp.ContentPackageId,
        this.options.sizes.M,
        cpp.ThumbnailId,
        cpp.ContentPackageVersion || this.CPackageInfo.Version
      );
    });
  }
}

export function sort(list) {
  return list.sort((a, b) => {
    return new Date(b.PublicationDate) - new Date(a.PublicationDate);
  });
}



// WEBPACK FOOTER //
// ./src/common/stores/cpStore.js